namespace TR {
    'use strict';

    class Review {
        author: string;
        date: string;
        rating: number;
        comment: string;
    }

    class AppPromo {
        benefits: { icon:string, title:string }[];
        why: string[];
        androidReviews: Review[];
        IOSReviews: Review[];
        overlay: { image: string, text: string };

        constructor(
            private analytics: any
        ) {
            this.analytics.track('mixpanel', 'AppPromoLanding');
            this.benefits = _.map(
                TRPCONFIG.Domain.AppPromoBenefits,
                (b:string) => {
                    const [icon, title] = _.split(b, '|');
                    return { icon, title };
                });

            this.why = TRPCONFIG.Domain.AppPromoWhy;
            this.androidReviews = _.map(TRPCONFIG.Domain.AppPromoAndroidReviews, this._parseReview);
            this.IOSReviews = _.map(TRPCONFIG.Domain.AppPromoIOSReviews, this._parseReview);
            this.overlay = {
                image: `url("${TRPCONFIG.Domain.AppPromoOverlayImage}")`,
                text: TRPCONFIG.Domain.AppPromoOverlayText
            };

            $.each({
                'title':
                    `<title>${TRPCONFIG.Domain.AppPromoMetaTitle}</title>`,
                'meta[name=title]':
                    `<meta name="title" content="${TRPCONFIG.Domain.AppPromoMetaTitle}">`,
                'meta[name=description]':
                    `<meta name="description" content="${TRPCONFIG.Domain.AppPromoMetaDescription}">`
                },
                (selector, htmlStr) => {
                    $(selector).remove();
                    $('head').append(htmlStr);
                }
            );
        }

        trackClick(appStore) {
            this.analytics.track('mixpanel', 'AppPromoClick', { appStore });
        }

        private _parseReview(review:string) : Review {
            const [ author, date, rating, comment ] = _.split(review, '|');
            return {
                author,
                date,
                rating: parseInt(rating, 10),
                comment
            };
        }
    }

    angular
        .module('TR')
        .controller('AppPromo', AppPromo);
}
